import styled from "styled-components";

interface IMacaronBadgeProps {
  $bgColor?: string;
}

// Base styles for all badges
export const BaseBadge = styled.span`
  padding: 1px 6px;
  display: inline-block;
  border-radius: 2px;
`;

// Classic badge (no color)
export const ClassicBadge = styled(BaseBadge)`
  // No specific background or color
`;

// Colored badge
export const ColorBadge = styled(BaseBadge)<IMacaronBadgeProps>`
  background-color: ${(props) => props.$bgColor};
`;

// Full width colored badge for border container
export const FullWidthColorBadge = styled(ColorBadge)`
  width: 100%;
  text-align: center;
`;
